var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ frame: _vm.framed, 'my-5': _vm.framed }},[(!_vm.framed)?_c('hr',{staticClass:"my-5 mx-auto",staticStyle:{"max-width":"200px"}}):_vm._e(),_vm._v(" "),_c('h2',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }